import React from 'react'

interface StateLink {
    Title?: string
    Link?: string
    Trakheesi_id?: string
    Status?: string
    Comment?: string
    Disabled?: boolean
}

interface IProps {
    stateLinks: StateLink[]
}
export default function SecondTryTable({ stateLinks }: IProps): JSX.Element {
    return (
        <>
            {stateLinks && stateLinks.length > 0
                ? stateLinks.map((lin: any, i: number) => {
                    const trakheesi = lin?.Trakheesi_id
                    const title = lin?.Title ?? lin?.Portal ?? 'Trakheesi ID'
                    const link = lin?.Link

                    const sts = lin?.Status ?? 'In-process'
                    const comment = lin?.Comment
                    const disabled = lin?.Disabled === true
                    return (

                        <div
                            key={`link-${i}`}
                            className={`card shadow-sm my-2 d-flex flex-row row g-0 p-1 me-1  align-items-start justify-content-between position-relative border border-1 border-${sts === 'Approved' ? 'success' : sts === 'In-process' ? 'warning' : 'danger'} bg-light-${sts === 'Approved' ? 'success' : sts === 'In-process' ? 'warning' : 'danger'}`}
                        >
                            <div className="d-flex">
                                <div className={'position-absolute top-1  translate-middle'} style={{ right: '-32px' }}>
                                    <span className={`badge me-2 badge-light-${sts === 'Approved' ? 'success' : sts === 'In-process' ? 'warning' : 'danger'}`}>{sts}</span>
                                </div>
                            </div>
                            <div className='py-4 px-2'>
                                {/* <div className={'d-flex justify-content-between align-items-center'}>
                                    <span className="text-dark fw-semi-bold fs-7 ">Title</span>
                                    <span className="text-gray-800 text-hover-primary fw-semi-bold fs-7 text-break">{title}</span>
                                </div>
                                <div className="separator border-dark-gray-400  separator-dashed"></div> */}
                                {/*  <div className={'d-flex justify-content-between align-items-center text-end'}>
                                    <span className="text-dark fw-semi-bold fs-7 ">Link</span>
                                    <a href={link} target={'_blank'} className="ps-4 text-endtext-primary text-break fw-semi-bold fs-7" rel="noreferrer">{link}</a></div>
                                <div className="separator border-dark-gray-400  separator-dashed "></div> */}
                                <div className={'d-flex justify-content-between align-items-center lh-1 text-end'}>
                                    <span className="text-dark fw-bold fs-6 me-2 ">Portal</span>
                                    <span className="text-gray-800 fs-7" style={{ wordWrap: 'break-word', wordBreak: 'break-all', whiteSpace: 'normal' }}>
                                        {title ?? '-'}
                                    </span>
                                </div>
                                {typeof link === 'string' && link.length > 0 && (
                                    <div className={'d-flex justify-content-between align-items-center lh-1 text-end mt-2'}>
                                        <span className="text-dark fw-bold fs-6 me-2 ">Link</span>
                                        <a href={link} target="_blank" rel="noreferrer" className="text-primary fs-7">{link}</a>
                                    </div>
                                )}
                                {typeof trakheesi === 'string' && trakheesi.length > 0 && (
                                    <div className={'d-flex justify-content-between align-items-center lh-1 text-end mt-2'}>
                                        <span className="text-dark fw-bold fs-6 me-2 ">Trakheesi ID</span>
                                        <span className="text-gray-800 fs-7">{trakheesi}</span>
                                    </div>
                                )}
                                {typeof comment === 'string' && comment.length > 0 && (
                                    <div className={'d-flex justify-content-between align-items-center lh-1 text-end mt-2'}>
                                        <span className="text-dark fw-bold fs-6 me-2 ">Comment</span>
                                        <span className="text-gray-800 fs-7">{comment}</span>
                                    </div>
                                )}
                                {disabled && (
                                    <div className='mt-2 text-end'>
                                        <span className='badge badge-light-dark'>Disabled</span>
                                    </div>
                                )}
                            </div>

                        </div>
                    )
                })
                : null
            }
        </>
    )
}
